import client from '../httpClient';

const libraryShareApi = (params) => {
  return client.post('/libraries/share/', params, { isShowLoading: false });
};

export default libraryShareApi;
